import { render, staticRenderFns } from "./ProductComponentIncludeByDefault.vue?vue&type=template&id=76ef2aac&"
import script from "./ProductComponentIncludeByDefault.vue?vue&type=script&lang=ts&"
export * from "./ProductComponentIncludeByDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports